import {type FC} from 'react';

import {observer} from 'mobx-react';

import type {Props} from './types';

import * as S from './styles';

export const Timeslot: FC<Props> = observer(
  ({isDisabled, isHidden, isSelected, label, onClick}) => {
    return (
      <S.Container
        disabled={isDisabled}
        isHidden={isHidden}
        isSelected={isSelected}
        onClick={onClick}
        scheme={isDisabled ? 'gray' : 'secondary'}
      >
        <S.Label isDisabled={isDisabled} isSelected={isSelected}>
          {label}
        </S.Label>
      </S.Container>
    );
  },
);
